var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _g, _ellipse5, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobspree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 712,
    height: 992,
    viewBox: "0 0 712 992",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.608 990.154L633.058 616.215L661.145 567.948L61.0406 581.375L80.469 618.757L353.608 990.154Z",
    fill: "#37323E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 378.772,
    cy: 356,
    rx: 378.772,
    ry: 356,
    transform: "matrix(0 -1 -1 0 712 757.544)",
    fill: "#37323E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.305,
    cy: 304.474,
    rx: 313.305,
    ry: 304.474,
    transform: "matrix(0 -1 -1 0 655.789 682.724)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.191,
    cy: 248.263,
    rx: 257.191,
    ry: 248.263,
    transform: "matrix(0 -1 -1 0 599.581 626.61)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_102_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 77,
    width: 515,
    height: 498
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.192,
    cy: 248.262,
    rx: 257.192,
    ry: 248.262,
    transform: "matrix(-0.999542 0.0302773 0.0301428 0.999546 546.147 70)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_102_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M530.049 290.968C523.569 278.16 510.266 270.257 495.918 270.692L491.061 270.839C476.155 271.29 462.436 262.749 456.264 249.173L419.681 168.71C404.883 136.164 357.107 141.456 349.783 176.453L344.915 199.716C344.506 201.666 343.942 203.58 343.225 205.439L327.772 245.549C318.772 268.909 289.659 276.78 270.12 261.136L249.707 244.794C231.233 230.003 203.811 236.123 193.373 257.367L167.532 309.961C164.123 316.9 162.973 324.732 164.243 332.357L179.855 426.092C182.614 442.659 196.186 455.287 212.908 456.848L567.152 489.918C596.136 492.623 616.753 462.345 603.612 436.371L530.049 290.968Z",
    fill: "#FFFB88"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_102_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 120,
    width: 515,
    height: 498
  }, _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.199,
    cy: 248.255,
    rx: 257.199,
    ry: 248.255,
    transform: "matrix(-0.998167 0.0600061 0.0600452 0.998227 593.432 105.97)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_102_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596.48 462.717C576.772 426.494 529.655 415.947 496.389 440.313V440.313C463.148 464.66 416.071 454.15 396.336 417.977L351.112 335.081C337.191 309.565 309.783 294.389 280.772 296.133L215.228 300.073C196.922 301.174 179.314 292.884 168.499 278.072V278.072C134.251 231.17 60.2589 264.211 72.3221 321.021L128.617 586.133C136.327 622.441 169.433 647.65 206.482 645.423L562.627 624.013C617.45 620.717 650.25 561.549 624.001 513.302L596.48 462.717Z",
    fill: "#A7B0FF",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.869 459.671C146.222 426.057 183.551 408.779 217.817 420.352L294.513 446.255C318.542 454.37 345.089 448.438 363.377 430.867L400.892 394.823C414.288 381.953 432.993 376.2 451.305 379.318V379.318C488.486 385.649 521.871 355.703 519.607 318.053L517.304 279.779C516.653 268.958 519.124 258.177 524.421 248.719V248.719C554.246 195.47 635.609 220.629 630.18 281.421L606.674 544.596C603.681 578.116 576.62 604.403 543.029 606.423L169.878 628.855C120.172 631.843 84.2163 582.147 102.601 535.867L132.869 459.671Z",
    fill: "#FF9B95",
    fillOpacity: 0.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobspree);
export default __webpack_public_path__ + "static/media/jobspree.4fef095b64144e81e5f80eee0f8fa0a2.svg";
export { ForwardRef as ReactComponent };